<template>
  <v-icon :color="getIconColor" small @click="$emit('click')">
    {{ getIcon }}
  </v-icon>
</template>

<script>
export default {
  name: "ReportIcon",
  props: ["type", "icons"],
  computed: {
    getIconColor() {
      if (!this.icons[this.type]) return "red";
      return this.icons[this.type].color;
    },
    getIcon() {
      if (!this.icons[this.type]) return "mdi-help-circle";
      return this.icons[this.type].icon;
    },
  },
};
</script>
